import React, { useState, useRef, useEffect } from "react";
import PropTypes from "prop-types";
import { get } from "lodash";
import { DeepBI } from "../../../integrations";
import Icon from "../icon";
import assetify from "@quintype/framework/assetify";
import logo from "../../../../assets/images/vikatan-100-logo.png";
import styles from "./styles.m.css";

export default function AISummaryWidget({ story, renderSocialMedia }) {
  const [showSummary, setShowSummary] = useState(false);
  const summaryRef = useRef(null);
  const [showShare, setShowShare] = useState(false);
  const shareBtnRef = useRef(null);
  const shareListRef = useRef(null);

  useEffect(
    () => {
      const handleClickOutside = event => {
        if (
          showShare &&
          shareBtnRef.current &&
          !shareBtnRef.current.contains(event.target) &&
          shareListRef.current &&
          !shareListRef.current.contains(event.target)
        ) {
          setShowShare(false);
        }
      };

      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    },
    [showShare]
  );

  const handleShowSummary = () => {
    setShowSummary(true);
    DeepBI.pingPaywallEventTrigger(story, "AISummaryClicked");
    setTimeout(() => {
      summaryRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
    }, 200);
    document.body.style.overflow = "hidden"; // prevent scroll when modal open
  };

  useEffect(() => {
    DeepBI.pingPaywallEventTrigger(story, "AISummaryButtonEnabled");
  }, []);

  const handleClose = () => {
    setShowSummary(false);
    DeepBI.pingPaywallEventTrigger(story, "AISummaryClosed");
    document.body.style.overflow = "auto";
  };

  const summaryText = get(story, ["metadata", "summary"], "AI summary not available.");
  const [summarySection, keyPoints] = splitSummary(summaryText);

  const handleShareClick = () => {
    DeepBI.pingPaywallEventTrigger(story, "AISummaryShare");
    setShowShare(!showShare);
  };

  return (
    <div className="ai-summary-container">
      <button className="ai-summary-btn" onClick={handleShowSummary} disabled={!get(story, ["metadata", "summary"])}>
        <Icon type="ai" /> Summary
      </button>

      {showSummary && (
        <div className="ai-summary-overlay" onClick={handleClose}>
          <div
            ref={summaryRef}
            className="ai-summary-card"
            onClick={e => e.stopPropagation()} // prevent closing when clicking inside card
          >
            <div className="ai-summary-icon-large">
              <Icon type="ai" />
            </div>
            <button className="ai-summary-close" onClick={handleClose}>
              <span>×</span>
            </button>
            <div className="ai-short-summary">
              <div>✨</div>
              <div>
                {" "}
                இந்தச் சுருக்கமானது, உங்கள் நேரத்தைத் திறம்பட மிச்சப்படுத்த, செயற்கை நுண்ணறிவு (AI) உதவியுடன் பரிசோதனை
                முயற்சியாக உருவாக்கப்பட்டது.
              </div>
            </div>
            <div className="ai-summary-content">
              <h2 className="ai-summary-title">Summary</h2>
              <p className="ai-summary-text">{summarySection}</p>
              {keyPoints.length > 0 && (
                <div>
                  {/* <h3 className="ai-summary-subtitle">Key Points</h3> */}
                  <ul className="ai-summary-list">
                    {keyPoints.map((point, i) => (
                      <li key={i}>
                        <img src="https://media.vikatan.com/vikatan/2026-01-19/p86snxd3/ai-icon.png" />
                        {point}
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
            <div className={styles["summary-footer"]}>
              <div>
                <img alt="Vikatan" src={assetify(logo)} className={styles["brand-logo"]} width="178px" height="50px" />
              </div>
              <div
                ref={shareBtnRef}
                className={`${styles["box-div"]} ${showShare ? styles["share-active"] : ""} `}
                onClick={handleShareClick}
              >
                <Icon type="socialshare" />
                <span className={`${styles["channel-txt"]} hidden-mobile`}>Share</span>
              </div>
              <div ref={shareListRef} className={`${styles["social-share-wrapper"]} ai-social-share-wrapper`}>
                {showShare && renderSocialMedia && renderSocialMedia("", false)}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

function splitSummary(rawText) {
  if (!rawText) return ["", []];

  const clean = rawText.replace(/\r/g, "").trim();

  // Remove PUSH TITLE and PUSH DESCRIPTION blocks completely
  const noPush = clean
    .replace(/PUSH TITLE[\s\S]*?(?=PUSH DESCRIPTION|$)/i, "")
    .replace(/PUSH DESCRIPTION[\s\S]*$/i, "")
    .trim();

  // Extract SUMMARY section
  let summarySection = "";
  const summaryMatch = noPush.match(/SUMMARY\s*(.+?)(?=\nBULLETS|$)/is);
  if (summaryMatch) {
    summarySection = summaryMatch[1].trim();
  }

  // Extract BULLETS section
  let keyPoints = [];
  const bulletsMatch = noPush.match(/BULLETS\s*([\s\S]+)/i);
  if (bulletsMatch) {
    const bulletsText = bulletsMatch[1].trim();

    keyPoints = bulletsText
      // eslint-disable-next-line no-useless-escape
      .split(/\n|•|(?<=^)[\-–]\s+/m) // <-- FIXED HERE
      .map(p => p.trim())
      .filter(Boolean);
  }

  return [summarySection, keyPoints];
}

AISummaryWidget.propTypes = {
  story: PropTypes.shape(),
  renderSocialMedia: PropTypes.func
};
